// extracted by mini-css-extract-plugin
export var dateLabel = "_redotech-redo-web-src-date-range-date-label";
export var dateLabelError = "_redotech-redo-web-src-date-range-date-label-error";
export var fullWidth = "_redotech-redo-web-src-date-range-full-width";